class WindowService {
  public static getProtocol(): string {
    if (window.top) {
      return window.top.location.protocol;
    }
    return '';
  }

  public static getHref(): string {
    if (window.top) {
      return window.top.location.href;
    }
    return '';
  }

  public static getSearch(): string {
    if (window.top) {
      return window.top.location.search;
    }
    return '';
  }

  public static getQueryStringMap(): URLSearchParams {
    const params = new URLSearchParams(WindowService.getSearch());
    return params;
  }

  public static getOrigin(): string {
    if (window.top) {
      return window.top.location.origin;
    }
    return '';
  }

  public static scrollTo(top: number): void {
    if (window.top) {
      window.top.scrollTo({ top, behavior: 'smooth' });
    }
  }

  public static navigate(uri: string): void {
    if (window.top) {
      window.top.location.replace(uri);
    }
  }

  public static reload(removeQueryString = false): void {
    if (!window.top) {
      return;
    }
    if (removeQueryString) {
      window.top.location.href = new URL(
        window.top.location.pathname,
        window.top.location.origin
      ).href;
    } else {
      window.top.location.reload();
    }
  }

  public static removeQueryString(): void {
    if (window.top) {
      const urlWithoutQueryString = new URL(
        window.top.location.pathname,
        window.top.location.origin
      ).href;
      window.history.pushState('', document.title, urlWithoutQueryString);
    }
  }
}

export default WindowService;
